import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./FundingEvaluationPayment.scss";
import AllAddressPopup from "./../../components/Popups/AllAddressPopup";
import AddNewAddressPopup from "./../../components/Popups/AddNewAddressPopup";
import axios from "axios";

import { getUserProfile } from "../../store/reducers/userProfileReducer";
import PaymentForm from "./PaymentForm";
import { axiosInstance } from "../../Axios";



const FundingEvaluationPayment = () => {
  const dispatch = useDispatch();
  const [editMode, setEditMode] = useState(0);
  
  // edit mode state 0: view mode, 1: edit General Info , 2: edit Billing Info, 3: edit address

  // all popup states
  const [allAddressPop, setAllAddressPop] = useState(false);
  const [addNewAddressPop, setAddNewAddressPop] = useState(false);

  const user_profile = useSelector((state) => state.user);
  const [FullName, setFullName] = useState();

  useEffect(() => {
    dispatch(getUserProfile());
  }, [dispatch]);

  const [Firstname, setFirstname] = useState("");
  const [Lastname, setLastname] = useState("");
  const [Email, setEmail] = useState();
  const [Contact, setContact] = useState();

  const handleChangeFirstname = (event) => {
    event.preventDefault();
    setFirstname(event.target.value);
  };

  const handleChangeLastname = (event) => {
    event.preventDefault();
    setLastname(event.target.value);
  };

  const handleChangeEmail = (event) => {
    event.preventDefault();
    setEmail(event.target.value);
  };

  const handleChangeContact = (event) => {
    event.preventDefault();
    setContact(event.target.value);
  };

  useEffect(() => {
    if (Object.keys(user_profile).length) {
      setFullName(user_profile.full_name);
      setEmail(user_profile.Email);
      setContact(user_profile.Contact_number);
      setFirstname(user_profile.First_name);
      setLastname(user_profile.Last_name);
    }
  }, [user_profile]);

  const handleSave = (e) => {
    e.preventDefault();
    setEditMode(0);

    const ProfileData = {
      full_name: FullName,
      contact_number: Contact,
      country: AddCountry,
      city: City,
    };
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    config.headers['AUTHORIZATION'] = ACCtoken;

    axiosInstance
      .post("v2/user/profile/create/", ProfileData, config)
      .then((res) => {
      });
  };




  const [AprtNo, setAprtNo] = useState();
  const handleChangeAprtNo = (e) => {
    e.preventDefault();
    setAprtNo(e.target.value);
  };
  const [street, setStreet] = useState();
  const handleChangeStreet = (e) => {
    e.preventDefault();
    setStreet(e.target.value);
  };
  const [State, setState] = useState();
  const handleChangeState = (e) => {
    e.preventDefault();
    setState(e.target.value);
  };
  const [Zip, setZip] = useState();
  const handleChangeZip = (e) => {
    e.preventDefault();
    setZip(e.target.value);
  };
  const [City, setCity] = useState();
  const handleChangeCity = (e) => {
    e.preventDefault();
    setCity(e.target.value);
  };
  const [AddCountry, setAddCountry] = useState();
  const handleChangeAddCountry = (e) => {
    e.preventDefault();
    setAddCountry(e.target.value);
  };

  const ACCtoken = useSelector((state) => state.ACCtoken);

  const handleSubmitAddAddress = (e) => {
    e.preventDefault();

    setAddNewAddressPop(false);

    const AddData = {
      Apt_no: AprtNo,
      State: State,
      Street: street,
      Zip: Zip,
      Country: AddCountry,
    };
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    config.headers['AUTHORIZATION'] = ACCtoken;
    axiosInstance
      .post("v2/user/address/create/", AddData, config)
      .then((res) => {
      })
      .catch(function (error) {
        console.log(error);
      });

    window.location.reload();
  };

  const [Data, setData] = useState([]);
  useEffect(() => {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    config.headers['AUTHORIZATION'] = ACCtoken;
    axiosInstance
      .get("v2/user/address/get/", config)
      .then((res) => {
        setData(res.data.data);
      });
  }, []);
  
  const [chosenAddress, setchosenAddress] = useState("0");
  const handleAddAddress = (data) => {
    setchosenAddress(data);
  };

  return (
    <div className="FundingEvaluationPaymentMAIN">
      <AllAddressPopup
        trigger={allAddressPop}
        setTrigger={setAllAddressPop}
        setTrigger3={setAddNewAddressPop}
        handleAddAddress={handleAddAddress}
      />
      <AddNewAddressPopup
        trigger={addNewAddressPop}
        setTrigger={setAddNewAddressPop}
        onSubmitHandle={handleSubmitAddAddress}
        AprtNo={AprtNo}
        handleChangeAprtNo={handleChangeAprtNo}
        street={street}
        handleChangeStreet={handleChangeStreet}
        State={State}
        handleChangeState={handleChangeState}
        Zip={Zip}
        handleChangeZip={handleChangeZip}
        City={City}
        handleChangeCity={handleChangeCity}
        AddCountry={AddCountry}
        handleChangeAddCountry={handleChangeAddCountry}
      />
      <div className="FundingEvaluationPaymentMAIN-L">
        <div className="DpboxCon FEFirst">
          <div className="DpboxCon-Top">
            General Information
            {editMode === 1 ? (
              <div
                // onClick={() => {
                //   setEditMode(0);
                // }}
                onClick={handleSave}
                className="saveChangeSCON"
              >
                Save Changes
              </div>
            ) : (
              <svg
                onClick={() => {
                  if (editMode === 1) {
                    setEditMode(0);
                  } else {
                    setEditMode(1);
                  }
                }}
                className="edtICON"
                width="17"
                height="18"
                viewBox="0 0 17 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M12.1369 0.46967C11.9963 0.329018 11.8055 0.25 11.6066 0.25C11.4077 0.25 11.2169 0.329018 11.0763 0.46967L1.88388 9.66206C1.78965 9.75628 1.72223 9.87391 1.68856 10.0028L0.688556 13.8313C0.621266 14.0889 0.695605 14.3629 0.88388 14.5511C1.07215 14.7394 1.34614 14.8138 1.60375 14.7465L5.43218 13.7465C5.56111 13.7128 5.67874 13.6454 5.77297 13.5511L14.9654 4.35876C15.2582 4.06586 15.2582 3.59099 14.9654 3.2981L12.1369 0.46967ZM3.08843 10.5788L11.6066 2.06066L13.3744 3.82843L4.8562 12.3466L2.46344 12.9716L3.08843 10.5788Z"
                  fill="white"
                />
                <path
                  d="M1 16.25C0.585786 16.25 0.25 16.5858 0.25 17C0.25 17.4142 0.585786 17.75 1 17.75H16C16.4142 17.75 16.75 17.4142 16.75 17C16.75 16.5858 16.4142 16.25 16 16.25H1Z"
                  fill="white"
                />
              </svg>
            )}
          </div>
          <div className="DpboxCon-Btm">
            {editMode === 1 ? (
              <div className="DpboxEDIT-Con">
                <div className="DpboxCon-Btm-tcon-editcon">
                  <h1>First Name</h1>
                  <input
                    value={Firstname}
                    type="text"
                    onChange={handleChangeFirstname}
                  />
                </div>
                <div className="DpboxCon-Btm-tcon-editcon">
                  <h1>Last Name</h1>
                  <input
                    value={Lastname}
                    type="text"
                    onChange={handleChangeLastname}
                  />
                </div>
                <div className="DpboxCon-Btm-tcon-editcon">
                  <h1>Email</h1>
                  <input
                    value={Email}
                    type="email"
                    onChange={handleChangeEmail}
                  />
                </div>
                <div className="DpboxCon-Btm-tcon-editcon">
                  <h1>Contact Number</h1>
                  <input
                    value={Contact}
                    type="number"
                    onChange={handleChangeContact}
                  />
                </div>
              </div>
            ) : (
              <>
                <div className="DpboxCon-Btm-tcon">
                  <h1>Full Name</h1>
                  <h2>
                    {Firstname} {Lastname} {FullName}
                  </h2>
                </div>
                <div className="DpboxCon-Btm-tcon tw">
                  <h1>Email</h1>
                  <h2>{Email}</h2>
                </div>
                <div className="DpboxCon-Btm-tcon thr">
                  <h1>Contact Number</h1>
                  <h2>{Contact}</h2>
                </div>
              </>
            )}
          </div>
        </div>
        <div className="DpboxCon FESecond dbmt">
          <div className="DpboxCon-Top">
            Billing Information
            {editMode === 2 ? (
              <div
                onClick={() => {
                  setEditMode(0);
                }}
                className="saveChangeSCON"
              >
                Save Changes
              </div>
            ) : (
              <svg
                onClick={() => {
                  if (editMode === 2) {
                    setEditMode(0);
                  } else {
                    setEditMode(2);
                  }
                }}
                className="edtICON"
                width="17"
                height="18"
                viewBox="0 0 17 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M12.1369 0.46967C11.9963 0.329018 11.8055 0.25 11.6066 0.25C11.4077 0.25 11.2169 0.329018 11.0763 0.46967L1.88388 9.66206C1.78965 9.75628 1.72223 9.87391 1.68856 10.0028L0.688556 13.8313C0.621266 14.0889 0.695605 14.3629 0.88388 14.5511C1.07215 14.7394 1.34614 14.8138 1.60375 14.7465L5.43218 13.7465C5.56111 13.7128 5.67874 13.6454 5.77297 13.5511L14.9654 4.35876C15.2582 4.06586 15.2582 3.59099 14.9654 3.2981L12.1369 0.46967ZM3.08843 10.5788L11.6066 2.06066L13.3744 3.82843L4.8562 12.3466L2.46344 12.9716L3.08843 10.5788Z"
                  fill="white"
                />
                <path
                  d="M1 16.25C0.585786 16.25 0.25 16.5858 0.25 17C0.25 17.4142 0.585786 17.75 1 17.75H16C16.4142 17.75 16.75 17.4142 16.75 17C16.75 16.5858 16.4142 16.25 16 16.25H1Z"
                  fill="white"
                />
              </svg>
            )}
          </div>
          <div className="DpboxCon-Btm">
            {editMode === 2 ? (
              <div className="DpboxEDIT-Con">
                <div className="DpboxCon-Btm-tcon-editcon">
                  <h1>Apartment No.</h1>
                  <input type="text" />
                </div>
                <div className="DpboxCon-Btm-tcon-editcon">
                  <h1>Street Address</h1>
                  <input type="email" />
                </div>
                <div className="DpboxCon-Btm-tcon-editcon">
                  <h1>State</h1>
                  <input type="number" />
                </div>
                <div className="DpboxCon-Btm-tcon-editcon">
                  <h1>Zip Code</h1>
                  <input type="number" />
                </div>
                <div className="DpboxCon-Btm-tcon-editcon">
                  <h1>Country</h1>
                  <input type="number" />
                </div>
              </div>
            ) : (
              <div className="DpboxCon-Btm-tcon">
                <h1>Billing Information</h1>
                <div>
                  {Object.keys(Data).map((data) => {
                    if (data === chosenAddress) {
                      return (
                        <h2>
                          {Data[data].Apt_no}, {Data[data].Street},
                          {Data[data].State}, {Data[data].Country},
                          {Data[data].Zip}
                        </h2>
                      );
                    }
                  })}
                </div>

                {/* <h2>
                  1623 Hunningon Place, 8 Lousiville, Kentucky, 40220, Canada
                </h2> */}
                <div className="DpboxCon-Btm-tcon thrrjr">
                  <div
                    onClick={() => {
                      setEditMode(3);
                      setAllAddressPop(true);
                    }}
                    className="btn-cad"
                  >
                    Change Address
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <PaymentForm/>
    </div>
  );
};

export default FundingEvaluationPayment;
